<template>
  <v-container class="pa-0 px-2">
    <v-row>
      <v-col class="pa-2" cols="12" sm="12" md="4">
        <v-card
          max-width="400px"
          height="195px"
          outlined
          style="box-shadow: 0 0 0px 2px #d0021b"
          class="p-card"
        >
          <v-card-text class="px-2 pt-2 pb-0">
            <v-row class="ma-0">
              <v-col class="px-0 pt-0 pb-0" cols="12">
                <v-toolbar flat>
                  <v-toolbar-title class="mr-1">
                    <p class="text-title mb-0 mt-0" style="color: #d0021b">
                      Com critica
                      <br />
                      <small>{{ list.qt_crono_critica }} CRONOGRAMAS</small>
                    </p>
                  </v-toolbar-title>
                  <v-toolbar-items class="mb-4 ml-2" width="20px">
                    <v-menu offset-y max-width="20%">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="px-0 py-0"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          icon
                        >
                          <v-icon
                            class="px-1 pt-0"
                            color="primary"
                            size="14px"
                            @click="openInfo = true"
                            >fa-info-circle</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-list class="px-3 pt-3 pb-0" outlined flat solo>
                        <p style="font-width: 24px">
                          Total de cronogramas que possuem lotes com críticas e
                          previsão de faturamento para o mês corrente.
                          <br /><br />
                          Número de lotes com críticas ou erros na etapa de
                          validação da estrutura do arquivo.
                          <br /><br />
                          Número de lotes com críticas ou erros retornados pela
                          operadora na etapa de transmissão.
                          <br /><br />
                          Valor total calculado nos lotes com alguma pendência.
                        </p>
                      </v-list>
                    </v-menu>
                  </v-toolbar-items>
                  <v-spacer></v-spacer>
                  <v-toolbar-items class="text-end mb-4 ml-3" width="20px">
                    <v-icon
                      class="pa-0"
                      color="primary"
                      size="20px"
                      @click="filter('Critica')"
                      >fa-external-link-alt</v-icon
                    >
                  </v-toolbar-items>
                </v-toolbar>
              </v-col>
              <v-col class="text-center px-0 py-0" cols="6">
                <p class="text-qtd">{{ list.qt_lote_critica_envio }}</p>
                <p class="text-legend">
                  LOTE COM ERRO <br />
                  DE TRASMISSÃO
                </p>
              </v-col>

              <v-col class="text-center px-0 py-0" cols="6">
                <p class="text-qtd" style="font-size: 16px">
                  {{ list.qt_lote_critica_validacao }}
                </p>
                <p class="text-legend">
                  LOTE COM ERRO <br />
                  DE VALIDAÇÃO
                </p>
              </v-col>

              <v-col class="text-center px-0 pb-0 pt-1" cols="12">
                <div class="value-text">{{list.vl_crono_critica | formatPrice}}</div>
                <p>VALOR PENDENTE</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col class="pa-2" cols="12" sm="12" md="4">
        <v-card
          max-width="400px"
          height="195px"
          outlined
          style="box-shadow: 0 0 0px 2px #fc9d0a"
          class="p-card"
        >
          <v-card-text class="px-0 pt-2 pb-0">
            <v-row class="ma-0">
              <v-col class="px-0 pt-1 pb-0" cols="12">
                <v-toolbar flat>
                  <v-toolbar-title class="mr-1">
                    <p class="text-title mb-0 mt-0" style="color: #fc9d0a">
                      Em atraso
                      <br />
                      <small>{{ list.qt_crono_atrasado }} CRONOGRAMAS</small>
                    </p>
                  </v-toolbar-title>
                  <v-toolbar-items class="mb-4 ml-2" width="20px">
                    <v-menu offset-y max-width="20%">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="px-0 py-0"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          icon
                        >
                          <v-icon
                            class="px-1 pt-0"
                            color="primary"
                            size="14px"
                            @click="openInfo = true"
                            >fa-info-circle</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-list class="px-3 pt-3 pb-0" outlined flat solo>
                        <p style="font-width: 24px">
                          Total de cronogramas em atraso referente a previsão de
                          faturamento cadastrada.
                        </p>
                      </v-list>
                    </v-menu>
                  </v-toolbar-items>
                  <v-spacer></v-spacer>
                  <v-toolbar-items class="text-end mb-4 ml-3" width="20px">
                    <v-icon
                      class="pa-0"
                      color="primary"
                      size="20px"
                      @click="filter('Atrasados')"
                      >fa-external-link-alt</v-icon
                    >
                  </v-toolbar-items>
                </v-toolbar>
              </v-col>
              <v-col class="text-center px-0 py-1" cols="12">
                <p class="text-qtd" style="font-size: 16px">
                  {{ list.qt_lote_atrasado }}
                </p>
                <p class="text-legend">LOTES</p>
              </v-col>

              <v-col class="text-center px-0 pb-0 pt-1" cols="12">
                <div class="value-text">{{list.vl_crono_atrasado | formatPrice}}</div>
                <p>VALOR PREVISTO</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col class="pa-2" cols="12" sm="12" md="4">

        <v-card
          max-width="400px"
          height="195px"
          outlined
          style="box-shadow: 0 0 0px 2px #fc5f17"
          class="p-card"
        >
          <v-card-text class="px-2 pt-2 pb-0">
            <v-row class="ma-0">
              <v-col class="px-0 pt-0 pb-0" cols="12">
                <v-toolbar flat>
                  <v-toolbar-title class="mr-1">
                    <p class="text-title mb-0 mt-0" style="color: #fc5f17">
                      Aguardando transmissão
                      <br />
                      <small>{{ list.qt_crono_envio }} CRONOGRAMAS</small>
                    </p>
                  </v-toolbar-title>
                  <v-toolbar-items class="mb-4 ml-2" width="20px">
                    <v-menu offset-y max-width="20%">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="px-0 py-0"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          icon
                        >
                          <v-icon
                            class="px-1 pt-0"
                            color="primary"
                            size="14px"
                            @click="openInfo = true"
                            >fa-info-circle</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-list class="px-3 pt-3 pb-0" outlined flat solo>
                        <p style="font-width: 24px">
                          Cronogramas que possuem lotes disponíveis.
                          <br /><br />
                          Para transmitir a operadora.
                          <br /><br />
                          Valor total de lotes a serem transmitidos.
                        </p>
                      </v-list>
                    </v-menu>
                  </v-toolbar-items>
                  <v-spacer></v-spacer>
                  <v-toolbar-items class="text-end mb-4 ml-3" width="20px">
                    <v-icon
                      class="pa-0"
                      color="primary"
                      size="20px"
                      @click="filter('AEnvio')"
                      >fa-external-link-alt</v-icon
                    >
                  </v-toolbar-items>
                </v-toolbar>
              </v-col>
              <v-col class="text-center px-0 py-0" cols="6">
                <p class="text-qtd">{{ list.qt_lote_envio }}</p>
                <p class="text-legend">
                  LOTES <br />
                  ENVIO AUTOMÁTICO
                </p>
              </v-col>

              <v-col class="text-center px-0 py-0" cols="6">
                <p class="text-qtd" style="font-size: 16px">
                  {{ list.qt_lote_envio_manual }}
                </p>
                <p class="text-legend">
                  LOTES <br />
                  ENVIO MANUAL
                </p>
              </v-col>

              <v-col class="text-center px-0 pb-0 pt-1" cols="12">
                <div class="value-text">{{list.vl_crono_envio | formatPrice}}</div>
                <p>VALOR CALCULADO</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col class="pa-2" cols="12" sm="12" md="4">
        <v-card
          max-width="400px"
          height="140px"
          outlined
          style="box-shadow: 0 0 0px 2px #d8dde6"
          class="p-card"
        >
          <v-card-text class="px-0 pt-2 pb-0">
            <v-row class="ma-0">
              <v-col class="px-0 pt-1 pb-0" cols="12">
                <v-toolbar flat>
                  <v-toolbar-title class="mr-1">
                    <p class="text-title mb-0 mt-0" style="color: ##4a4a4a">
                      Não iniciados
                      <br />
                      <small
                        >{{ list.qt_crono_nao_iniciados }} CRONOGRAMAS</small
                      >
                    </p>
                  </v-toolbar-title>
                  <v-toolbar-items class="mb-4 ml-2" width="20px">
                    <v-menu offset-y max-width="20%">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="px-0 py-0"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          icon
                        >
                          <v-icon
                            class="px-1 pt-0"
                            color="primary"
                            size="14px"
                            @click="openInfo = true"
                            >fa-info-circle</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-list class="px-3 pt-3 pb-0" outlined flat solo>
                        <p style="font-width: 24px">
                          Cronogramas programados para serem iniciados na
                          vigência atual e não foram vinculados a lotes.
                        </p>
                      </v-list>
                    </v-menu>
                  </v-toolbar-items>
                  <v-spacer></v-spacer>
                  <v-toolbar-items class="text-end mb-4 ml-3" width="20px">
                    <v-icon
                      class="pa-0"
                      color="primary"
                      size="20px"
                      @click="filter('NaoIniciados')"
                      >fa-external-link-alt</v-icon
                    >
                  </v-toolbar-items>
                </v-toolbar>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="pa-2" cols="12" sm="12" md="4">
        <v-card
          max-width="400px"
          height="140px"
          outlined
          style="box-shadow: 0 0 0px 2px #d8dde6"
          class="p-card"
        >
          <v-card-text class="px-0 pt-2 pb-0">
            <v-row class="ma-0">
              <v-col class="px-0 pt-1 pb-0" cols="12">
                <v-toolbar color="rgba(0,0,0,0)" flat>
                  <v-toolbar-title class="mr-1">
                    <p class="text-title mb-0 mt-0" style="color: #4a4a4a">
                      Lotes em processamento
                      <br />
                      <small
                        >{{ list.qt_crono_processamento }} CRONOGRAMAS</small
                      >
                    </p>
                  </v-toolbar-title>
                  <v-toolbar-items class="mb-4 ml-2" width="20px">
                    <v-menu offset-y max-width="20%">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="px-0 py-0"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          icon
                        >
                          <v-icon
                            class="px-1 pt-0"
                            color="primary"
                            size="14px"
                            @click="openInfo = true"
                            >fa-info-circle</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-list class="px-3 pt-3 pb-0" outlined flat solo>
                        <p style="font-width: 24px">
                          Lotes em processamento, sendo validação Tiss e lotes
                          em transmissão para operadora.
                        </p>
                      </v-list>
                    </v-menu>
                  </v-toolbar-items>
                  <v-spacer></v-spacer>
                  <v-toolbar-items class="text-end mb-4 ml-3" width="20px">
                    <v-icon
                      class="pa-0"
                      color="primary"
                      size="20px"
                      @click="filter('Processando')"
                      >fa-external-link-alt</v-icon
                    >
                  </v-toolbar-items>
                </v-toolbar>
              </v-col>
              <div class="px-4" style="position: absolute; height:2px; margin-top:0; text-align: left; width: 100%; font-size:11px">
                 ENVIO AUTOMÁTICO
              </div>

              <v-col class="text-center px-0 py-1" cols="6">
                <p class="text-qtd" style="font-size: 16px">
                  {{ list.qt_lote_processamento_validacao }}
                </p>
                <p class="text-legend">
                  LOTES EM <br />
                  VALIDAÇÃO
                </p>
              </v-col>

              <v-col class="text-center px-0 py-1" cols="6">
                <p class="text-qtd" style="font-size: 16px">
                  {{ list.qt_lote_processamento_envio }}
                </p>
                <p class="text-legend">
                  LOTES EM <br />
                  ENVIO
                </p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="pa-2" cols="12" sm="12" md="4">
        <v-card
          max-width="400px"
          height="140px"
          outlined
          style="box-shadow: 0 0 0px 2px #d8dde6"
          class="p-card"
        >
          <v-card-text class="px-0 pt-2 pb-0">
            <v-row class="ma-0">
              <v-col class="px-0 pt-1 pb-0" cols="12">
                <v-toolbar color="rgba(0,0,0,0)" flat>
                  <v-toolbar-title class="mr-1">
                    <p class="text-title mb-0 mt-0" style="color: #4a4a4a">
                      Lotes em processamento
                      <br />
                      <small
                        >{{ list.qt_crono_processamento_manual }} CRONOGRAMAS</small
                      >
                    </p>
                  </v-toolbar-title>
                  <v-toolbar-items class="mb-4 ml-2" width="20px">
                    <v-menu offset-y max-width="20%">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="px-0 py-0"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          icon
                        >
                          <v-icon
                            class="px-1 pt-0"
                            color="primary"
                            size="14px"
                            @click="openInfo = true"
                            >fa-info-circle</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-list class="px-3 pt-3 pb-0" outlined flat solo>
                        <p style="font-width: 24px">
                          Lotes em processamento, sendo validação Tiss e lotes
                          em transmissão para operadora.
                        </p>
                      </v-list>
                    </v-menu>
                  </v-toolbar-items>
                  <v-spacer></v-spacer>
                  <v-toolbar-items class="text-end mb-4 ml-3" width="20px">
                    <v-icon
                      class="pa-0"
                      color="primary"
                      size="20px"
                      @click="filter('ProcessandoManual')"
                      >fa-external-link-alt</v-icon
                    >
                  </v-toolbar-items>
                </v-toolbar>
                
              </v-col>
           
            <div class="px-4" style="position: absolute; height:2px; margin-top:0; text-align: left; width: 100%; font-size:11px">
                 ENVIO MANUAL
              </div>
  
              <v-col class="text-center px-0 py-1" cols="6">
                <p class="text-qtd" style="font-size: 16px">
                  {{ list.qt_lote_processamento_validacao_manual }}
                </p>
                <p class="text-legend">
                  LOTES EM <br />
                  VALIDAÇÃO
                </p>
              </v-col>

              <v-col class="text-center px-0 py-1" cols="6">
                <p class="text-qtd" style="font-size: 16px">
                  {{ list.qt_lote_processamento_capa_lote_manual }}
                </p>
                <p class="text-legend">
                  LOTES<br />
                  AGUARDANDO CAPA
                </p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- <v-card
          max-width="400px"
          height="140px"
          outlined
          style="box-shadow: 0 0 0px 2px #d8dde6"
          class="p-card"
        >
          <v-card-text class="px-0 pt-2 pb-0">
            <v-row class="ma-0">
              <v-col class="px-0 pt-1 pb-0" cols="12">
                <v-toolbar flat>
                  <v-toolbar-title class="mr-1">
                    <p class="text-title mb-0 mt-0" style="color: #4a4a4a">
                      Lotes em edição
                      <br />
                      <small>20 CRONOGRAMAS</small>
                    </p>
                  </v-toolbar-title>
                  <v-toolbar-items class="mb-4 ml-2" width="20px">
                    <v-menu offset-y max-width="20%">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="px-0 py-0"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          icon
                        >
                          <v-icon
                            class="px-1 pt-0"
                            color="primary"
                            size="14px"
                            @click="openInfo = true"
                            >fa-info-circle</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-list class="px-3 pt-3 pb-0" outlined flat solo>
                        <p style="font-width: 24px">
                          Número de cronogramas
                          que possuem lotes em
                          edição.
                          <br /><br>
                          Número de lotes que
                          estão abertos e
                          bloqueados com algum
                          usuário do sistema.
                        </p>
                      </v-list>
                    </v-menu>
                  </v-toolbar-items>
                  <v-spacer></v-spacer>
                  <v-toolbar-items class="text-end mb-4 ml-3" width="20px">
                    <v-icon
                      class="pa-0"
                      color="primary"
                      size="20px"
                      @click="filter('cronograma')"
                      >fa-external-link-alt</v-icon
                    >
                  </v-toolbar-items>
                </v-toolbar>
              </v-col>
              <v-col class="text-center px-0 py-1" cols="12">
                <p class="text-qtd" style="font-size: 16px">13</p>
                <p class="text-legend">LOTES EM EDIÇÃO</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card> -->
      </v-col>
      <v-col class="pa-2" cols="12" sm="12" md="4">
        <v-card
          max-width="400px"
          height="240px"
          outlined
          style="box-shadow: 0 0 0px 2px #d8dde6"
          class="p-card"
          v-if="parameters && parameters.ITG_API_SITE"
        >
          <v-card-text class="px-0 pt-2 pb-0">
            <v-row class="ma-0">
              <v-col class="px-0 pt-1 pb-0" cols="12">
                <v-toolbar flat>
                  <v-toolbar-title class="mr-1">
                    <p class="text-title mb-0 mt-0" style="color: #4a4a4a">
                      Lotes sem cronograma
                      <br />
                      <small
                        >{{
                          (total =
                            list.qt_lote_sem_cronograma_ok +
                            list.qt_lote_sem_cronograma_critica)
                        }}
                        LOTES</small
                      >
                    </p>
                  </v-toolbar-title>
                  <v-toolbar-items class="mb-4 ml-2" width="20px">
                    <v-menu offset-y max-width="20%">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="px-0 py-0"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          icon
                        >
                          <v-icon
                            class="px-1 pt-0"
                            color="primary"
                            size="14px"
                            @click="openInfo = true"
                            >fa-info-circle</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-list class="px-3 pt-3 pb-0" outlined flat solo>
                        <p style="font-width: 24px">
                          Total de lotes não vinculados a um cronograma
                          importados no mês corrente.
                          <br /><br />
                          Número de lotes validados e disponíveis para associar
                          a um cronograma.
                          <br /><br />
                          Número de lotes com criticas ou erros na etapa de
                          validação da estrutura do arquivo.
                        </p>
                      </v-list>
                    </v-menu>
                  </v-toolbar-items>
                  <v-spacer></v-spacer>
                  <v-toolbar-items class="text-end mb-4 ml-3" width="20px">
                    <v-icon
                      color="primary"
                      size="20px"
                      @click="filter('sem-cronograma')"
                      >fa-external-link-alt</v-icon
                    >
                  </v-toolbar-items>
                </v-toolbar>
              </v-col>
              <v-col class="text-center px-0 py-1" cols="4">
                <p class="text-qtd" style="font-size: 16px">
                  {{ list.qt_lote_sem_cronograma_ok }}
                </p>
                <p class="text-legend">
                  LOTES <br />
                  VALIDADOS
                </p>
              </v-col>
              <v-col class="text-center px-0 py-1" cols="4">
                <p class="text-qtd" style="font-size: 16px">
                  {{ list.qt_lote_sem_cronograma_validacao }}
                </p>
                <p class="text-legend">
                  LOTES <br />
                  EM VALIDAÇÃO
                </p>
              </v-col>
              <v-col class="text-center px-0 py-1" cols="4">
                <p class="text-qtd" style="font-size: 16px">
                  {{ list.qt_lote_sem_cronograma_critica }}
                </p>
                <p class="text-legend">
                  LOTES COM ERRO <br />
                  DE VALIDAÇÃO
                </p>
              </v-col>

              <v-col class="text-center px-0 pb-0 pt-3" cols="12">
                <div class="value-text">{{ (list.vl_lote_sem_cronograma_ok + list.vl_lote_sem_cronograma_critica + list.qt_lote_sem_cronograma_validacao) | formatPrice}}</div>
                <p>VALOR CALCULADO</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col class="pa-2" cols="12" sm="12" md="4">
        <v-card
          max-width="400px"
          height="240px"
          outlined
          style="box-shadow: 0 0 0px 2px #d8dde6"
          class="p-card"
        >
          <v-card-text class="px-0 pt-2 pb-0">
            <v-row class="ma-0">
              <v-col class="px-0 pt-1 pb-0" cols="12">
                <v-toolbar flat>
                  <v-toolbar-title class="mr-1">
                    <p class="text-title mb-0 mt-0" style="color: #4a4a4a">
                      Aguardando conclusão
                      <br />
                      <small
                        >{{
                          list.qt_crono_aguardando_conclusao
                        }}
                        CRONOGRAMAS</small
                      >
                    </p>
                  </v-toolbar-title>
                  <v-toolbar-items class="mb-4 ml-2" width="20px">
                    <v-menu offset-y max-width="20%">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="px-0 py-0"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          icon
                        >
                          <v-icon
                            class="px-1 pt-0"
                            color="primary"
                            size="14px"
                            @click="openInfo = true"
                            >fa-info-circle</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-list class="px-3 pt-3 pb-0" outlined flat solo>
                        <p style="font-width: 24px">
                          Total de Cronogramas aguardando conclusão de
                          fechamento.
                          <br /><br />
                          Número de lotes vinculados aos cronogramas.
                          <br /><br />
                          Valor total de cronogramas transmitidos (realizado).
                          <br /><br />
                          Valor previsto de cronogramas planejados.
                        </p>
                      </v-list>
                    </v-menu>
                  </v-toolbar-items>
                  <v-spacer></v-spacer>
                  <v-toolbar-items class="text-end mb-4 ml-3" width="20px">
                    <v-icon
                      class="pa-0"
                      color="primary"
                      size="20px"
                      @click="filter('AConcluir')"
                      >fa-external-link-alt</v-icon
                    >
                  </v-toolbar-items>
                </v-toolbar>
              </v-col>
              <v-col class="text-center px-0 py-0" cols="12">
                <p class="text-qtd" style="font-size: 16px">
                  {{ list.qt_lote_aguardando_conclusao }}
                </p>
                <p class="text-legend">LOTES</p>
              </v-col>
              <v-col class="text-center px-0 pb-0 pt-0" cols="12">
                <div class="value-text">{{list.vl_crono_aguardando_conclusao | formatPrice}}</div>
                <p>VALOR TRANSMITIDO</p>
              </v-col>
              <v-col class="text-center px-0 pb-0 pt-0" cols="12">
                <div class="value-text">{{list.vl_crono_aguardando_conclusao_previsto | formatPrice}}</div>
                <p>VALOR PREVISTO</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col class="pa-2" cols="12" sm="12" md="4">
        <v-card
          max-width="400px"
          height="240px"
          outlined
          style="box-shadow: 0 0 0px 2px #32b88b"
          class="p-card"
        >
          <v-card-text class="px-0 pt-2 pb-0">
            <v-row class="ma-0">
              <v-col class="px-0 pt-1 pb-0" cols="12">
                <v-toolbar flat>
                  <v-toolbar-title class="mr-1">
                    <p class="text-title mb-0 mt-0" style="color: #32b88b">
                      Concluídos
                      <br />
                      <small>{{ list.qt_crono_concluido }} CRONOGRAMAS</small>
                    </p>
                  </v-toolbar-title>
                  <v-toolbar-items class="mb-4 ml-2" width="20px">
                    <v-menu offset-y max-width="20%">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="px-0 py-0"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          icon
                        >
                          <v-icon
                            class="px-1 pt-0"
                            color="primary"
                            size="14px"
                            @click="openInfo = true"
                            >fa-info-circle</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-list class="px-3 pt-3 pb-0" outlined flat solo>
                        <p style="font-width: 24px">
                          Total de cronogramas concluídos na vigência atual.
                          <br /><br />
                          Valor transmitido para operadora.
                          <br /><br />
                          Valor planejado de cronogramas.
                        </p>
                      </v-list>
                    </v-menu>
                  </v-toolbar-items>
                  <v-spacer></v-spacer>
                  <v-toolbar-items class="text-end mb-4 ml-3" width="20px">
                    <v-icon
                      class="pa-0"
                      color="primary"
                      size="20px"
                      @click="filter('Concluidos')"
                      >fa-external-link-alt</v-icon
                    >
                  </v-toolbar-items>
                </v-toolbar>
              </v-col>
              <v-col class="text-center px-0 py-0" cols="12">
                <p class="text-qtd" style="font-size: 16px">
                  {{ list.qt_lote_concluido }}
                </p>
                <p class="text-legend">LOTES</p>
              </v-col>
              <v-col class="text-center px-0 pb-0 pt-0" cols="12">
                <div class="value-text">{{list.vl_crono_concluido | formatPrice}}</div>
                <p>VALOR TRANSMITIDO</p>
              </v-col>
              <v-col class="text-center px-0 pb-0 pt-0" cols="12">
                <div class="value-text">{{list.vl_crono_concluido_previsto | formatPrice}}</div>
                <p>VALOR PREVISTO</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  filters: {
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return 'R$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  },
  props: {
    list: Object,
    filter: Function,
    parameters: Object
  },
};
</script>

<style scoped>
.text-title {
  font-size: 20px;
  font-weight: 700;
  font-family: "Cairo";
  line-height: 15px;
}
small {
  font-size: 12px;
  font-weight: 500;
  font-family: "Cairo";
}
.text-legend {
  font-size: 10px;
  line-height: 12px;
}
.v-toolbar__content .v-btn.v-btn--icon.v-size--default,
.v-toolbar__extension .v-btn.v-btn--icon.v-size--default {
  height: 0px;
  width: 0px;
}
.text-qtd {
  font-family: "Cairo";
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 3px !important;
}
.theme--light.v-icon:focus::after {
  display: none !important;
}
.value-text{
  font-size: 18px;
  font-family: "Cairo";
  color: #272525d1;
  font-weight: 600;
}
</style>